import { Component, OnInit } from '@angular/core';
import { NodeService } from '../../shared/services/nodeservice.service';
import { Downloads } from '../../shared/services/downloads';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-downloads',
  templateUrl: './downloads.component.html'
})
export class DownloadsComponent implements OnInit {

    loading: boolean;
    files1: Downloads[];
    selectedNode1: Downloads;

    cols: any[];

    constructor(private title: Title, private nodeService: NodeService) {
        this.title.setTitle('Downloads | XYZ Corp. Verification Workspace');
    }

    ngOnInit() {

        this.loading = true;
        this.nodeService.getDownloads().then(files => this.files1 = files);

        this.cols = [
            { field: 'submittedDate', header: 'Submitted Date' },
            { field: 'applicationNo', header: 'Application No.' },
            { field: 'applicantName', header: 'Applicant Name' },
            { field: 'state', header: 'State' },
            { field: 'appliedAmount', header: 'Applied Amount' }
            //{ field: 'aml', header: 'AML' }
        ];
    }

}
